module.exports = __webpack_public_path__ + "img/tower.3faca646.png";